module.exports = __webpack_public_path__ + "cover-letter-47f61a13/template-5-09bf74ea0fcee26b48ae7375e6454061.jpg";